import { ArrowLeft, Construction } from 'lucide-react';
import { Button } from '../ui/button.js';

interface DummyViewProps {
  title: string;
  onBack: () => void;
}

export function DummyView({ title, onBack }: DummyViewProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full w-full bg-slate-50 text-slate-500 animate-in fade-in duration-300">
      <div className="max-w-md text-center space-y-6">
        <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Construction className="h-10 w-10 text-blue-500" />
        </div>

        <h2 className="text-3xl font-bold text-slate-800">{title}</h2>
        <p className="text-lg">
          Diese Seite befindet sich noch im Aufbau.
          <br />
          Hier kommen bald die Details zu <strong>{title}</strong> hin.
        </p>

        <div className="pt-8">
          <Button onClick={onBack} variant="outline" className="gap-2">
            <ArrowLeft className="h-4 w-4" />
            Zurück zum Chat
          </Button>
        </div>
      </div>
    </div>
  );
}
